import actionType from '../actions/goodsManagement/actionType';

export const initialSearchValue = {
  pageNum: 1,
  pageSize: 50,
  goodsName: '',
  posShowFlag: null,
  selfShowFlag: null,
  categoryId: null,
  categoryParentId: null,
  categoryTopId: null,
};

const initialState = {
  goodsManagementList: [],
  laundryList: [],
  goodsManagementLoading: false,
  goodsRoomsLoading: false,
  laundryLoading: false,
  exportLoading: false,
  goodsSearchValue: { ...initialSearchValue },
  laundrySearchValue: {
    skuCode: null,
    startDate: null,
    endDate: null,
    operationType: null,
    changeArea: null,
    pageNum: 1,
    pageSize: 50,
  },
  goodsTotal: 0,
  laundryTotal: 0,
  roomsList: [],

  // 商品引入
  filterGoodsObj: {
    spuName: '',
  },
  introGoodsList: [],
  introGoodsTotal: 0,
  introGoodsLoading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionType.GOODS_MANAGEMENT_LSIT:
      return {
        ...state,
        goodsManagementList: action.payload.goodsManagementList,
        goodsTotal: action.payload.goodsTotal,
        goodsSearchValue: {
          ...state.goodsSearchValue,
          pageNum: action.payload.pageNum,
        },
      };
    case actionType.GOODS_LAUNDREY_LSIT:
      return {
        ...state,
        laundryList: action.payload.laundryList,
        laundryTotal: action.payload.laundryTotal,
        laundrySearchValue: {
          ...state.laundrySearchValue,
          pageNum: action.payload.pageNum,
        },
      };
    case actionType.UPDATE_GOODS_MANAGEMENT_STATE:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.SET_GOODS_SEARCH_VALUE:
      return {
        ...state,
        goodsSearchValue: {
          ...state.goodsSearchValue,
          ...action.payload,
        },
      };
    case actionType.SET_LAUNDRY_SEARCH_VALUE:
      return {
        ...state,
        laundrySearchValue: {
          ...state.laundrySearchValue,
          ...action.payload,
        },
      };
    case actionType.ROOM_LIST:
      return {
        ...state,
        roomList: action.payload.roomList,
      };
    // 商品引入
    case actionType.SET_FILTER_GOODS_OBJ:
      return {
        ...state,
        filterGoodsObj: {
          ...state.filterGoodsObj,
          ...action.payload,
        },
      };
    case actionType.INTRO_GOODS_LIST:
      return {
        ...state,
        introGoodsList: action.payload.introGoodsList,
        introGoodsTotal: action.payload.introGoodsTotal,
        filterGoodsObj: {
          ...state.filterGoodsObj,
        },
      };
    case actionType.RESET_GOODS_INTRO_DATA:
      return {
        ...state,
        filterGoodsObj: {
          spuName: '',
        },
        introGoodsList: [],
      };
    default:
      return {
        ...state,
        ...action.payload,
      };
  }
};
